"use strict";
/**
 *  picDetailModule
 *
 * Description 策划中心 实时线索 计划性线索 监测跟踪 图片详情
 * Author Qian.qianchen 2019-06-18
 */
angular.module('picDetailModule', [])
    .controller('picDetailCtrl', ["$scope", "$state", '$element', "trsHttpService", "trsspliceString",
        function($scope, $state, $element, trsHttpService, trsspliceString) {
            initStatus();
            getData();

            function initStatus() {
                let resoucetype = {
                    0: "相关热点",
                    1: "相关政策",
                    2: "内部报道",
                    3: "一级媒体报道",
                    4: "地域",
                    5: "关键词",
                    6: "关联稿件",
                    7: "关联图片"
                };
                $scope.data = {
                    imgList: [],
                    trackname: '“' + $state.params.trackname + '”-',
                    resoucetype: resoucetype[$state.params.resoucetype],
                };
                $scope.page = {
                    "CURRPAGE": 0,
                    "PAGESIZE": 10
                };
                $scope.params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackPics',
                    "id": $state.params.trackid,
                    "page_no": $scope.page.CURRPAGE,
                    "page_size": $scope.page.PAGESIZE,
                };

            }
            /**
             * [getData description]数据请求函数(图片数据分页获取)
             * @return {[obj]} [description]
             */
            function getData() {
                $scope.params.page_no = $scope.page.CURRPAGE;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "get").then(function(data) {
                    let pageitems = data.PAGEITEMS;
                    $scope.data.imgList = $scope.data.imgList.concat(pageitems) || [];
                    $scope.page = {
                        CURRPAGE: data.PAGEINDEX,
                        PAGESIZE: data.PAGESIZE,
                        ITEMCOUNT: data.TOTALITEMCOUNT,
                        PAGECOUNT: data.PAGETOTAL
                    };
                });
            }
            /**
             * [loadMore description] 图集-加载更多图片
             * @return {[type]} [description]
             */
            function imgLoadMore() {
                $scope.page.CURRPAGE++;
                getData();
            };
            /**
             * [scrollShowMore description] 滚动加载更多
             * @return {[type]} [description]
             */
            $scope.scrollShowMore = function() {
                if ($scope.page.CURRPAGE < $scope.page.PAGECOUNT) {
                    isToButtom();
                }
            };
            /**
             * [isToButtom description] 判断是否到底
             * @return {Boolean} [description]
             */
            function isToButtom() {
                var $parentEl = $element.find(".resource_body_part");
                var parentHeight = $parentEl[0].offsetHeight;
                var scrollHeight = $parentEl[0].scrollHeight;
                var scrollTop = $parentEl.scrollTop();
                if (scrollTop / (scrollHeight - parentHeight) >= 0.9) {
                    imgLoadMore()
                }
            };
            /**
             * [goBack description] 返回上一页
             */
            $scope.goBack = function() {
                window.history.go(-1)
            }
        }
    ]);